import { useTranslation } from "react-i18next";
import { QUICK_PERCENTS } from "./itemDiscountMath";

/** Изборът за един ред: `null` = следва общата, 0 = без отстъпка, иначе
 *  собственият процент на реда. */
export type RowPercentChoice = number | null;

interface RowPercentOptionsProps {
  generalPercent: number;
  active: RowPercentChoice;
  onPick: (choice: RowPercentChoice) => void;
}

/** Лентата „За този ред" под разгънат ред: „Обща · N%", „Без" и бързите
 *  проценти. Собствен процент извън бързите (напр. 12 %) също е chip, за да
 *  се вижда кой е активният. */
export const RowPercentOptions = ({
  generalPercent,
  active,
  onPick,
}: RowPercentOptionsProps) => {
  const { t } = useTranslation();
  const percents =
    active !== null && active > 0 && !QUICK_PERCENTS.includes(active)
      ? [...QUICK_PERCENTS, active].sort((a, b) => a - b)
      : QUICK_PERCENTS;

  return (
    <div className="flex flex-wrap items-center gap-1.5 border-t border-dashed border-pos-line px-3 py-2.5">
      <span className="mr-1 text-[12px] font-medium text-pos-muted">
        {t("itemDiscounts.forThisRow")}
      </span>
      <OptionChip
        label={t("itemDiscounts.followGeneral", { percent: generalPercent })}
        active={active === null}
        onClick={() => onPick(null)}
      />
      <OptionChip
        label={t("itemDiscounts.none")}
        active={active === 0}
        onClick={() => onPick(0)}
      />
      {percents.map((value) => (
        <OptionChip
          key={value}
          label={`${value}%`}
          active={active === value}
          onClick={() => onPick(value)}
          mono
        />
      ))}
    </div>
  );
};

const OptionChip = ({
  label,
  active,
  onClick,
  mono,
}: {
  label: string;
  active: boolean;
  onClick: () => void;
  mono?: boolean;
}) => (
  <button
    type="button"
    onClick={onClick}
    className={`h-8 cursor-pointer whitespace-nowrap rounded-full border px-3 text-[12px] font-bold transition-colors ${
      mono ? "font-pos-mono" : ""
    } ${
      active
        ? "border-pos-accent bg-pos-accent text-white"
        : "border-pos-ctl bg-pos-card text-pos-soft2 hover:bg-pos-marked"
    }`}
  >
    {label}
  </button>
);
